import { render, staticRenderFns } from "./messagesComponent.vue?vue&type=template&id=9385556e&scoped=true"
import script from "./messagesComponent.vue?vue&type=script&lang=js"
export * from "./messagesComponent.vue?vue&type=script&lang=js"
import style0 from "./messagesComponent.vue?vue&type=style&index=0&id=9385556e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9385556e",
  null
  
)

export default component.exports